<template>
  <el-row class="wrap">
   <el-col :md="8" :sm="16" :xs="24">
      <div class="inner-wrap">
        <div class="text-top">
          <div class="logo-box">
            <img src="/static/logo360tovisit.png" alt="" width="185px">
          </div>
          <p class="slogan">{{ $t('Create new account!') }}</p>
        </div>
        <el-form :model="userInfo" :rules="rules" ref="loginForm" @submit.native.prevent class="form-login">
          <el-form-item label="" prop="name">
            <el-input type="text" v-model="userInfo.name" class="input-form" :placeholder="$t('Name')"></el-input>
          </el-form-item>
          <el-form-item label="" prop="username">
            <el-input type="text" v-model="userInfo.username" class="input-form" :placeholder="$t('Username')"  >
            </el-input>
            <span style="font-size: 10px;
            font-style: italic;
            color: #ffffff80;
            line-height: 10px;
            display: inherit;
            margin-top: 5px;">Example: http://vt.360tovisit.com/tour/{user name}/{project name}</span>
          </el-form-item>
          <el-form-item label="" prop="email">
            <el-input v-model="userInfo.email" prefix-icon="fa fa-user" class="input-form" :placeholder="$t('Email')"></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model="userInfo.password" prefix-icon="fa fa-unlock-alt" class="input-form" :placeholder="$t('Password')"></el-input>
          </el-form-item>
          <el-form-item label="" prop="agree">
            <el-checkbox v-model="userInfo.agree">
              <span style="white-space: normal; color: #ddd;">By signing up, you agree to 360tovisit's <a target="_blank" href="https://360tovisit.com/terms.html" style="color: #ddd">Terms of Use</a> and <a target="_blank" href="https://360tovisit.com/privacy-policy.html" style="color: #ddd">Privacy Policy</a></span>
            </el-checkbox>
          </el-form-item>
          <el-button class="submit-btn" :disable="!canSubmit" :loading="!canSubmit" @click="submitForm('loginForm')" native-type="submit">{{ $t('Register') }}</el-button>
          <div class="text-bottom">
            <span class="text-center" @click="$router.push({name: 'account-login'})">{{ $t('Already have an 360visit account?') }} {{ $t('Log in') }}</span>
          </div>
          <div class="text-bottom">
            <span class="text-center" @click="showActiveAccount = true">{{ $t('Your account not actived?') }} {{ $t('Active now!') }}</span>
          </div>
        </el-form>
      </div>
   </el-col>
   <el-dialog style="z-index: 9999;" :title="$t('Account confirmation')" :visible.sync="showActiveAccount" width="320px">
     <el-form>
       <el-row>
        <el-col :span="24">
          <el-alert
            :title="$t('We have sent you an activation code to complete your account creation')"
            type="success"
            style="margin-bottom: 10px;">
          </el-alert>
          <el-form-item>
            <el-input size="medium" type="text" :placeholder="$t('Email')" v-model="activeInfo.email"></el-input>
            <el-input size="medium" type="text" :placeholder="$t('Input your activation code here')" v-model="activeInfo.active_code"></el-input>
          </el-form-item>
          <div class="action-text">
            <span class="text-center" @click="resendActiveCode()">{{ $t('Resend the activation code') }}</span>
          </div>
          <el-button size="medium" :disable="!canSubmit" :loading="!canSubmit" type="primary" @click="sendCode()">Confirm</el-button>
        </el-col>
       </el-row>
     </el-form>
   </el-dialog>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { register, active, resendEmailActive } from '@/api/account'
export default {
  name: 'Register',
  data () {
    var validateCheckbox = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('You need to confirm our agreements')))
      } else {
        callback()
      }
    }
    return {
      canSubmit: true,
      userInfo: {
        name: '',
        username: '',
        email: '',
        password: '',
        agree: false
      },
      rules: {
        name: [
          { required: true, message: this.$t('Name is required') }
        ],
        username: [
          { required: true, message: this.$t('Username is required') }
        ],
        email: [
          { required: true, message: this.$t('Email is required') }
        ],
        password: [
          { required: true, message: this.$t('Password is required') },
          { min: 6, message: this.$t('At least x characters', {x: 6}) }
        ],
        agree: [
          { validator: validateCheckbox }
        ]
      },
      activeInfo: {
        active_code: '',
        email: ''
      },
      showActiveAccount: false,
      registerRecently: false,
      showHelpDialog: false,
      helpUsername: true
    }
  },
  computed: {
    ...mapGetters('account', ['logged', 'accountInfo']),
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  mounted () {
    this.helpUsername = !this.isMobile
    if (this.logged) {
      this.$router.push({name: 'home-index'})
    }
  },
  methods: {
    ...mapActions('account', ['setAccountInfo']),
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.canSubmit = false
          register(this.userInfo).then(response => {
            this.canSubmit = true
            switch (response.status) {
              case 1:
                this.activeInfo.email = this.userInfo.email
                this.showHelpDialog = false
                this.showActiveAccount = true
                this.registerRecently = true
                window.analytics.track('userregistration', {
                  accountType: 'Email'
                })
                break
              case 0:
                this.message422(response.errors.message)
                break
              default:
                this.messageError()
                this.$router.push({name: 'account-login'})
                break
            }
          })
        } else {
          this.$notify({
            title: 'Error',
            message: this.$t('Check your information'),
            type: 'warning'
          })
        }
      })
    },
    sendCode () {
      if (this.activeInfo.active_code && this.activeInfo.email) {
        this.canSubmit = false
        active(this.activeInfo).then(response => {
          this.canSubmit = true
          switch (response.status) {
            case 1:
              this.$notify({
                title: this.$t('Activation successful'),
                message: this.$t('You can log in now!'),
                type: 'success'
              })
              this.showActiveAccount = false
              this.$router.push({name: 'account-login'})
              break
            case 0:
              this.message422(response.errors.message)
              break
            default:
              this.messageError()
              this.$router.push({name: 'account-login'})
              break
          }
        })
      }
    },
    openHelpDialog () {
      this.showHelpDialog = true
    },
    resendActiveCode () {
      this.$prompt(this.$t('Please input your email address'), this.$t('Resend your activation code'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('Cancel'),
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: this.$t('Invalid email address')
      }).then(({ value }) => {
        resendEmailActive({email: value}).then(res => {
          switch (res.status) {
            case 1:
              this.$message({
                type: 'success',
                message: this.$t('Activation code sent! Please check your email inbox (or spam folder)')
              })
              break
            case 0:
              this.message422(res.errors.message)
              break
            default:
              this.messageError()
              break
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .wrap {
    padding: 0px 8px;
    min-height: 100vh;
    background-color: #2e3a4a;
    display: flex;
    vertical-align: middle;
    justify-content: center;
    color: #fff;
    background-size: cover;
    background-position: center center;
    background-image: url('/static/login_background_mobile.jpg');
  }
  .text-top {
    width: 500px;
    margin-top: 0px;
  }
  .logo-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slogan {
    text-align: center;
    line-height: 24px;
    font-size: 18px;
    color: #eeeeee;
    margin-top: 10px;
    margin-bottom: 0px;
  }
  .title {
    text-align: center;
    line-height: 43px;
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;
    color: #eeeeee;
    margin-top: 25px;
    margin-bottom: 0px;
  }
  .inner-wrap {
    max-width: 380px;
    height: 560px;
    margin: 50px auto 10px auto;
    padding: 10px 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #00000014;
    border-radius: 5px;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border: 1px solid #ffffff3b;
  }
  .text-top {
    width: 100%;
  }
  .form-login {
    max-width: 300px;
    padding: 20px 0px 0px 0px;
    margin: 0px auto;
  }
  .submit-btn {
    width: 100%;
    border-radius: 8px;
    background-color: #409eff;
    color: #fff;
    border: none;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .text-bottom {
    margin-top: 15px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 300;
    color: #eeeeee;
    cursor: pointer;
  }
  .el-icon-info {
    cursor: pointer;
  }
  @media screen and (min-width: 768px) {
    .wrap {
      height: 100vh;
      background-size: cover;
      background-position: bottom right;
      background-image: url('/static/login_background.jpg');
    }
    .inner-wrap {
      margin-top: 0px;
      width: 380px;
      top: calc((100vh - 600px)/2);
      left: calc((100vw/2 - 380px)/2);
      background-color: #00000014;
      position: fixed;
      border-radius: 5px;
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
      border: 1px solid #ffffff3b;
    }
    /*Exception for Firefox*/
    @supports (not (-webkit-backdrop-filter: none)) and (not (backdrop-filter: none)) {
      .inner-wrap {
        background-color: #00000059 !important;
      }
    }
  }
</style>
<style type="text/css">
  .tooltip {
    display: block !important;
    z-index: 2;
  }
  /*.vue-tooltip-theme {
    top: 26px !important;
    left: 2px !important;
  }*/

  .tooltip .tooltip-inner {
    background-color: #00000014;
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    color: #fff;
    border-radius: 5px;
    padding: 5px 10px 4px;
    max-width: 220px;
  }

  .tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #00000014;
    z-index: 1;
  }

  .tooltip[x-placement^="top"] {
    margin-bottom: 5px;
  }

  .tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }

  .tooltip[x-placement^="bottom"] {
    margin-top: 5px;
  }

  .tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
  }

  .tooltip[x-placement^="right"] {
    margin-left: 5px;
  }

  .tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  .tooltip[x-placement^="left"] {
    margin-right: 5px;
  }

  .tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  .tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: black;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(black, .1);
  }

  .tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
  }

  .tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  .tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
  .action-text {
    margin-bottom: 10px;
    cursor: pointer;
    color: #2795d3;
  }
  .el-checkbox {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Register.vue